import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  apiCreateCropCycle,
  apiCropCyclesList,
  apiGetPartnerCropsList,
  apiUpdateCropCycle,
} from "services/CropServices";


export const getPartnerCropsList = createAsyncThunk(
  "cropCycles/data/getPartnerCropsList",
  async (data) => {
    const response = await apiGetPartnerCropsList(data?.query);
    return ({cropData: response.data, userActiveId: data?.user});
  }
);

export const getCropCycleList = createAsyncThunk(
  "cropCycles/data/getCropCycleList",
  async (id) => {
    const response = await apiCropCyclesList(id);
    return response.data;
  }
);




export const initArrayTabs = ["chooseCrops", "choosePackages", "assignPackages", "chooseTimelines", "choosePractices"];


export const initAccessSlice = {
  isCropCycleCreateForm: false,
  isContentExpertRight: false,
  cropEditRight: [],

}
export const initCropCyclesFilters = {
  total: 0,
  loading: false,
  pageIndex: 1,
  pageSize: 5,
  cropsCycleTable: [],
  showTableData: [],
  query: "",
  sort: {
    order: "",
    key: "",
  },
};

export const inititalBreadArray = [{ href: null, label: 'Crops' }];
const cropCycles = createSlice({
  name: "cropCycles",
  initialState: {
    initTab: "chooseCrops",
    arrayStepTabs: initArrayTabs,
    cropsList: [],
    cropCycleAccess: initAccessSlice,
    filtersCropCycles: initCropCyclesFilters,
    userCropRights:[],
    initialBreadCrumb: inititalBreadArray
  },
  reducers: {
    updateInitTab: (state, action) => {
      state.initTab = action.payload;
    },

    setCropFilterPageIndex: (state, action) => {
      state.filtersCropCycles.pageIndex = action.payload;
    },
    setCropQueryPage: (state, action) => {
      state.filtersCropCycles.query = action.payload;
    },
    setCropFilterPageSize: (state, action) => {
      state.filtersCropCycles.pageSize = action.payload;
    },
    setCropFilterSort: (state, action) => {
      state.filtersCropCycles.sort = action.payload;
    },
    updateShowTableData: (state, action) => {
      state.filtersCropCycles.showTableData = action.payload;
    },
    updateTotalList:(state, action)=>{
      state.filtersCropCycles.total = action.payload;
    },
    updateBreadCrumb:(state, action)=>{
      state.initialBreadCrumb = action.payload
    },
    updateListData : (state, action)=>{ //!
      let {showTableData, filterTableData} = action.payload;
      state.filtersCropCycles.showTableData = showTableData;
      state.filtersCropCycles.cropsCycleTable = filterTableData;
    }
  },
  
  extraReducers: {
    [getPartnerCropsList.fulfilled]: (state, action) => {
      const checkUserExpert = action.payload.userActiveId;
      const activeUserContentRight = ((action?.payload?.cropData?.data?.attributes?.tenePartnerUsers?.data)?.length? 
        ((action?.payload?.cropData?.data?.attributes?.tenePartnerUsers?.data)?.find((n)=> n?.id === checkUserExpert))? 
          (((action?.payload?.cropData?.data?.attributes?.tenePartnerUsers?.data)?.find((n)=> n?.id === checkUserExpert))?.attributes?.tene_partner_user_info?.data?.attributes?.crop_edit_rights?.data)?.length?
            (((action?.payload?.cropData?.data?.attributes?.tenePartnerUsers?.data)?.find((n)=> n?.id === checkUserExpert))?.attributes?.tene_partner_user_info?.data?.attributes?.crop_edit_rights?.data)?.map((n)=> n?.id)
          :[] 
        :  []  
      : [])
      var modifiedData = action?.payload?.cropData?.data?.attributes?.crop_connects?.data?.length ? action?.payload?.cropData?.data?.attributes?.crop_connects?.data : [];
      modifiedData = modifiedData?.map((item) => ({ value: item?.id, label: item?.attributes?.cropName ? item?.attributes?.cropName : "" }));
      state.userCropRights = activeUserContentRight;
      state.cropsList = modifiedData;
    },
    [getPartnerCropsList.rejected]: (state) => {
      state.cropsList = [];
    },
    [getPartnerCropsList.pending]: (state) => {
      state.cropsList = [];
    },

    [getCropCycleList.fulfilled]: (state, action) => {
      let finalCropCycles = action?.payload.data;
      const { filtersCropCycles: {pageIndex, pageSize, query, sort }} = (JSON.parse(JSON.stringify(state)));
      if (query) {
        finalCropCycles = finalCropCycles?.filter((n) => ((n?.attributes?.crop_connect?.data?.attributes?.cropName)?.toLowerCase())?.includes(query));
      }

      if (!sort?.order && !sort?.key) {
        finalCropCycles?.sort((a, b) => {
        const dateA = new Date(a?.attributes?.createdAt || 0);
        const dateB = new Date(b?.attributes?.createdAt || 0);
        return dateB - dateA;  
    });
      } else {
        if (sort?.order && sort?.key) {
          if (sort?.key === 'asc') {
            finalCropCycles?.sort((a, b) => a?.attributes[sort?.key] - b?.attributes[sort?.key]);
          }
          if (sort?.key === 'desc') {
            finalCropCycles?.sort((a, b) => b?.attributes[sort?.key] - a?.attributes[sort?.key]);
          }
        }
      }

      let startIndex = (parseInt(parseInt(pageIndex - 1) * pageSize) ? parseInt(parseInt(parseInt(pageIndex - 1) * pageSize)) : parseInt(parseInt(pageIndex - 1) * pageSize))
      let endIndex = parseInt((pageIndex * pageSize))
      let filterData = finalCropCycles?.slice(startIndex, endIndex);



      state.filtersCropCycles.loading = false;
      state.filtersCropCycles.total = finalCropCycles?.length;
      state.filtersCropCycles.cropsCycleTable = finalCropCycles;
      state.filtersCropCycles.showTableData = filterData;
    },
    [getCropCycleList.rejected]: (state) => {
      state.filtersCropCycles.loading = false;
      state.filtersCropCycles.cropsCycleTable = [];
    },
    [getCropCycleList.pending]: (state) => {
      state.filtersCropCycles.loading = true;
      state.filtersCropCycles.cropsCycleTable = [];
    }
  },
});

export const {
  updateShowTableData,
  setCropQueryPage,
  updateInitTab,
  setCropFilterPageIndex,
  setCropFilterPageSize,
  setCropFilterSort,
  updateTotalList,
  updateBreadCrumb,
  updateListData
} = cropCycles.actions;

export default cropCycles.reducer;

export const saveCropCycles = async (data, SuccessCallBack, ErrorCallBack) => {
  await apiCreateCropCycle(data)
    .then(({ status, data: { data, message } }) => {
      if (status && status === 201) {
        SuccessCallBack({ success: true, message: message, data: data });
      } else {
        ErrorCallBack({ success: false, message: message });
      }
    })
    .catch(({ message }) => {
      ErrorCallBack({ success: false, message: message });
    });
};

export const updateCropCycles = async (id, data, SuccessCallBack, ErrorCallBack) => {
  await apiUpdateCropCycle(id, data).then(({ status, data: { data, message } }) => {
    if (status && status === 200) {
      SuccessCallBack({ success: true, message: message, data: data });
    } else {
      ErrorCallBack({ success: false, message: message });
    }
  }).catch(({ message }) => {
    ErrorCallBack({ success: false, message: message });
  });
};
